import { lazy, Suspense } from 'react';
import { Loader } from '@/shared/ui';
import type { Props } from './DashboardViewer';

const DashboardViewer = lazy(() =>
  import('./DashboardViewer').then(({ DashboardViewer }) => ({
    default: DashboardViewer,
  })),
);

export function DashboardViewerLazy(props: Props) {
  return (
    <Suspense fallback={<Loader active />}>
      <DashboardViewer {...props} />
    </Suspense>
  );
}
